import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "diamonds-search-form-range pt-4 pb-2 px-10" }
const _hoisted_2 = {
  key: 0,
  class: "relative !w-full h-16 mb-4"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "absolute top-6 left-0 w-full px-[2px]" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-[10px] text-gray-500 whitespace-nowrap mt-1 uppercase tracking-tighter font-medium text-center group-hover:text-brand-main" }

import { computed, ref, onMounted, onUnmounted, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormRange',
  props: {
    filter: { default: () => ({}) },
    activeValue: { default: () => [] }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const valuesKeys = computed(() => Object.keys(props.filter.values || {}));
const valuesCount = computed(() => valuesKeys.value.length);

const sliderRef = ref<HTMLElement | null>(null);
const isDragging = ref<'min' | 'max' | null>(null);

// Get initial indices from activeValue
const getInitialIndices = () => {
  if (!props.activeValue || props.activeValue.length === 0) {
    return { min: 0, max: valuesCount.value - 1 };
  }
  const indices = props.activeValue.map(v => valuesKeys.value.indexOf(v)).filter(i => i !== -1);
  if (indices.length === 0) return { min: 0, max: valuesCount.value - 1 };
  return {
    min: Math.min(...indices),
    max: Math.max(...indices)
  };
};

const initialIndices = getInitialIndices();
const localMinIdx = ref(initialIndices.min);
const localMaxIdx = ref(initialIndices.max);

watch(() => props.activeValue, () => {
  if (!isDragging.value) {
    const indices = getInitialIndices();
    localMinIdx.value = indices.min;
    localMaxIdx.value = indices.max;
  }
}, { deep: true });

const getPercentage = (index: number) => {
  if (valuesCount.value <= 1) return 0;
  return (index / (valuesCount.value - 1)) * 100;
};

const minPercent = computed(() => getPercentage(localMinIdx.value));
const maxPercent = computed(() => getPercentage(localMaxIdx.value));

const handleMouseDown = (type: 'min' | 'max') => {
  isDragging.value = type;
};

const handleMouseMove = (e: MouseEvent | TouchEvent) => {
  if (!isDragging.value || !sliderRef.value) return;

  const rect = sliderRef.value.getBoundingClientRect();
  const clientX = 'touches' in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
  const offsetX = clientX - rect.left;
  const percentage = Math.max(0, Math.min(100, (offsetX / rect.width) * 100));
  
  const index = Math.round((percentage / 100) * (valuesCount.value - 1));

  if (isDragging.value === 'min') {
    localMinIdx.value = Math.min(index, localMaxIdx.value);
  } else {
    localMaxIdx.value = Math.max(index, localMinIdx.value);
  }
};

const handleMouseUp = () => {
  if (isDragging.value) {
    const selectedValues = valuesKeys.value.slice(localMinIdx.value, localMaxIdx.value + 1);
    emit("update", selectedValues);
  }
  isDragging.value = null;
};

const handleLabelClick = (index: number) => {
  const distMin = Math.abs(index - localMinIdx.value);
  const distMax = Math.abs(index - localMaxIdx.value);

  if (distMin <= distMax) {
    localMinIdx.value = index;
  } else {
    localMaxIdx.value = index;
  }

  const selectedValues = valuesKeys.value.slice(localMinIdx.value, localMaxIdx.value + 1);
  emit("update", selectedValues);
};

onMounted(() => {
  window.addEventListener('mousemove', handleMouseMove);
  window.addEventListener('mouseup', handleMouseUp);
  window.addEventListener('touchmove', handleMouseMove, { passive: false });
  window.addEventListener('touchend', handleMouseUp);
});

onUnmounted(() => {
  window.removeEventListener('mousemove', handleMouseMove);
  window.removeEventListener('mouseup', handleMouseUp);
  window.removeEventListener('touchmove', handleMouseMove);
  window.removeEventListener('touchend', handleMouseUp);
});

const getImageUrl = (value: string) => {
  if (!props.filter.image) return '';
  const processedVal = props.filter.lowercaseImage !== false ? value.toLowerCase() : value;
  return props.filter.image.replace("{value}", processedVal);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.filter.type === 'icon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valuesKeys.value, (key, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'icon-' + key,
              class: "absolute -translate-x-1/2 bottom-0 transition-all duration-100 cursor-pointer w-12",
              style: _normalizeStyle({ left: getPercentage(index) + '%' }),
              onClick: ($event: any) => (handleLabelClick(index))
            }, [
              _createElementVNode("img", {
                src: getImageUrl(key),
                class: _normalizeClass(["w-12 h-12 object-contain rounded-full bg-white transition-opacity", index >= localMinIdx.value && index <= localMaxIdx.value ? 'opacity-100' : 'opacity-40']),
                alt: ""
              }, null, 10, _hoisted_4)
            ], 12, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "relative w-full h-1 bg-gray-200 rounded-full mb-10",
      ref_key: "sliderRef",
      ref: sliderRef
    }, [
      _createElementVNode("div", {
        class: "absolute h-full bg-brand-main rounded-full",
        style: _normalizeStyle({ left: minPercent.value + '%', right: (100 - maxPercent.value) + '%' })
      }, null, 4),
      _createElementVNode("div", {
        class: "absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5 bg-brand-main border-2 border-brand-main rounded-full cursor-pointer z-10 touch-none shadow-sm",
        style: _normalizeStyle({ left: minPercent.value + '%' }),
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (handleMouseDown('min'))),
        onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleMouseDown('min')), ["prevent"]))
      }, null, 36),
      _createElementVNode("div", {
        class: "absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5 bg-brand-main border-2 border-brand-main rounded-full cursor-pointer z-10 touch-none shadow-sm",
        style: _normalizeStyle({ left: maxPercent.value + '%' }),
        onMousedown: _cache[2] || (_cache[2] = ($event: any) => (handleMouseDown('max'))),
        onTouchstart: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleMouseDown('max')), ["prevent"]))
      }, null, 36),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valuesKeys.value, (key, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "flex flex-col items-center absolute cursor-pointer group",
            style: _normalizeStyle([{"width":"0","overflow":"visible"}, { left: getPercentage(index) + '%' }]),
            onClick: ($event: any) => (handleLabelClick(index))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-[1px] h-1.5 bg-gray-300 -translate-y-6 group-hover:bg-brand-main" }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.filter.values[key]), 1)
          ], 12, _hoisted_6))
        }), 128))
      ])
    ], 512)
  ]))
}
}

})